import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { getProductTypeCollection, ProductTypeCollectionModel } from "@tCentro/Services/CENAdminProductTypeService";

export interface GetProductTypeCollectionParameter
    extends HasOnSuccess<ProductTypeCollectionModel>,
        HasOnError<string> {}

type HandlerType = ApiHandler<GetProductTypeCollectionParameter, { apiResult: ProductTypeCollectionModel }>;
export interface GetProductTypeCollectionParameter extends HasOnSuccess<ProductTypeCollectionModel>, HasOnError<string> {
    page?: number;
    pageSize?: number;
    query?: string;
}

export const GetProductTypeCollection: HandlerType = async props => {
    try {
        const result = await getProductTypeCollection(props.parameter.page, props.parameter.pageSize,props.parameter.query);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to load product types");
        }
    }
};

export const chain = [GetProductTypeCollection];
const getProductTypeCollectionData = createHandlerChainRunner(chain, "getProductTypeCollectionData");
export default getProductTypeCollectionData;
